<template>
    <div id="app">
        <div class="content">
            <client-only>
                <Header v-if="$device.isDesktop" />
                <HeaderMobile v-else />
                <!--            <NotifyVPN></NotifyVPN>-->
                <div class="sub-header" v-if="showCrumbs">
                    <div class="container">
                        <breadcrumbs />
                    </div>
                </div>
            </client-only>
            <div class="page text_11">
                <div class="page__content">
                    <div class="text_13 page__title">{{ $t("customer_help") }}</div>
                    <div class="container helps-container">
                        <div v-if="$device.isDesktop" class="row help-lg">
                            <div class="col lg-3 sidebar">
                                <div class="sidebar__tabs">
                                    <nuxt-link to="/dostavka/" class="tab">
                                        <span class="tab__label" v-if="$route.path != '/dostavka/'">{{
                                            $t("help_delivery")
                                        }}</span>
                                        <h1 class="tab__label" v-else>{{ $t("help_delivery") }}</h1>
                                    </nuxt-link>
                                    <nuxt-link to="/vozvrat/" class="tab">
                                        <span class="tab__label" v-if="$route.path != '/vozvrat/'">{{
                                            $t("return")
                                        }}</span>
                                        <h1 class="tab__label" v-else>{{ $t("return") }}</h1>
                                    </nuxt-link>
                                    <nuxt-link to="/faq/" class="tab">
                                        <span class="tab__label" v-if="$route.path != '/faq/'">{{ $t("faq") }}</span>
                                        <h1 class="tab__label" v-else>{{ $t("faq") }}</h1>
                                    </nuxt-link>
                                    <nuxt-link to="/payment/" class="tab">
                                        <span class="tab__label" v-if="$route.path != '/faq/'">{{
                                            $t("payment")
                                        }}</span>
                                        <h1 class="tab__label" v-else>{{ $t("payment") }}</h1>
                                    </nuxt-link>
                                    <nuxt-link
                                        v-if="$device.isDesktop"
                                        class="tab tab--last"
                                        to="/dokumenty/"
                                        :class="{ 'nuxt-link-active': $route.name == 'dokumenty-slug' }">
                                        <span class="tab__label">{{ $t("docs") }}</span>
                                    </nuxt-link>
                                </div>
                                <div class="documents">
                                    <div
                                        class="documents__list"
                                        v-if="$route.name == 'dokumenty-slug' || $route.name == 'dokumenty'">
                                        <nuxt-link
                                            :to="`/dokumenty/${slug}/`"
                                            v-for="(title, slug) in documents"
                                            :key="slug">
                                            <div class="documents__item">
                                                <span>{{ title }}</span>
                                            </div>
                                        </nuxt-link>
                                    </div>
                                </div>
                                <div class="sidebar__footer text_11">
                                    <PPSCallBack />
                                </div>
                            </div>

                            <div class="col lg-9 p0 help-container">
                                <div class="help">
                                    <div class="help__item">
                                        <nuxt />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="$device.isMobile" class="help-sm">
                            <transition mode="out-in" name="fade-in-left">
                                <nuxt />
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <client-only>
            <FooterMobile v-if="$device.isMobile" />
            <NotifyModal />
            <SubscribePopup2 />
            <CookiesModal />
            <!--        <CountryModal/>-->
        </client-only>
    </div>
</template>
<script>
import Header from "@/components/Header.vue";
import HeaderMobile from "@/components/HeaderMobile.vue";
import FooterMobile from "@/components/FooterMobile.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import PPSCallBack from "@/components/PPSCallBack.vue";
import NotifyModal from "@/components/NotifyModal.vue";
// import CountryModal from "@/components/CountryModal.vue";
import { mapGetters } from "vuex";
// import NotifyVPN from "../components/NotifyVPN.vue";
import SubscribePopup2 from "@/components/ui/SubscribePopup2.vue";
import CookiesModal from "@/components/ui/CookiesModal.vue";

export default {
    name: "App",
    components: {
        SubscribePopup2,
        // NotifyVPN,
        Header,
        HeaderMobile,
        Breadcrumbs,
        FooterMobile,
        PPSCallBack,
        NotifyModal,
        CookiesModal,
        // CountryModal
    },

    data() {
        return {
            changed: false,
            activeModal: null,
            activeInModal: null,
            documents: [],
            isMac: false,
        };
    },
    watch: {
        $device() {
            if (this.$device.isIos || this.$device.isMacOS) this.isMac = true;
        },
        langust() {
            this.$axios.get("/api/documents").then((res) => {
                this.documents = res.data;
                this.$store.commit("crumbs/change", this.crumbs);
            });
        },
    },
    computed: {
        ...mapGetters({
            langust: "globalvars/getLang",
        }),
        bodyClass() {
            let bodyClass = this.$device.isDesktop ? "is_desktop" : "is_mobile";
            bodyClass += this.isMac ? " is_apple" : "";
            bodyClass += " page-" + this.$route.name;
            bodyClass += this.showCrumbs ? "" : " no-subheader";

            return bodyClass;
        },

        showCrumbs() {
            return this.$device.isDesktop && this.$route.name !== "index";
        },
    },
    head() {
        return {
            meta: [{ rel: "canonical", href: "https://post-post-scriptum.com" + this.$route.path }],
            bodyAttrs: {
                class: this.bodyClass,
            },
        };
    },
    methods: {
        showModal(name) {
            this.activeModal = name;
        },
        showInModal(name) {
            this.activeInModal = name;
        },
    },
    mounted() {
        this.isMac = this.$device.isIos || this.$device.isMacOS;

        this.$axios.get("/api/documents").then((res) => {
            this.documents = res.data;
        });
        if (this.$device.isDesktop) {
            document.querySelector("body").style.setProperty("--footer-height", 0 + "px");
        }
    },
};
</script>
<style lang="less">
.page {
    &__content {
        display: flex;
        flex-direction: column;
    }
}
.help-lg {
    width: 100%;
    margin: 0 !important;
    @media screen and (max-width: 830px) {
        display: none;
    }
}
.help-sm {
    display: none;
    @media screen and (max-width: 830px) {
        display: block;
        width: 100%;
        padding: 0 16px;
    }
}

.sidebar {
    background: #fff;
    border-right: 1px solid @border2;
    padding: 36px 32px !important;
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    &__tabs {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        .tab {
            cursor: pointer;
            &__label {
                display: inline-block;
                padding-bottom: 6px;
                margin-bottom: 16px;
                border-bottom: 1px transparent;
            }
            @media screen and (max-width: 830px) {
                padding: 12px 0px;
                border-bottom: 1px solid @border2;
                &__label {
                    padding-bottom: 0px;
                    margin-bottom: 0px;
                    border-bottom: none;
                }
                &__title {
                    &.is_open {
                        margin-bottom: 20px;
                    }
                }
            }
            &.is_active {
                .tab__label {
                    margin-bottom: 15px;
                    border-bottom: 1px solid #000;
                }
            }
        }
    }
    &__footer {
        color: #000;
        margin-top: auto;
        position: sticky;
        position: -webkit-sticky;
        bottom: 36px;
        z-index: 3;
        @media @sm {
            padding-top: 36px;
        }
    }
    .nuxt-link-active {
        .tab__label {
            margin-bottom: 15px;
            border-bottom: 1px solid #000;
        }
    }
    &--sm {
        border-right: none;
        margin: 0 -16px;
        padding: 24px 16px !important;
        margin-bottom: -32px;
        height: auto;
    }
}

.helps-container {
    display: flex;
    width: 100%;
    padding: 0 !important;
    @media screen and (max-width: 830px) {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
}

.help {
    flex-grow: 1;
    &__item {
        padding: 32px;
    }
}

.help-container {
    position: relative;
    height: 100%;
    @media screen and (max-width: 830px) {
        padding: 0;
    }
}

.documents {
    &__list {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        // border-bottom: 1px solid @border2;
        @media screen and (max-width: 830px) {
            padding-bottom: 16px;
        }
    }
    &__item {
        font-style: normal;
        font-weight: normal;
        font-size: 9px;
        line-height: 140%;
        letter-spacing: 0.16em;
        margin-bottom: 8px;
        cursor: pointer;
        border-bottom: 1px transparent;
        @media screen and (max-width: 830px) {
            margin-bottom: 20px;
            &:last-child {
                margin-bottom: 0;
            }
        }
        .nuxt-link-active & {
            span {
                border-bottom: 0;
                color: @accent;
            }
        }
        &.is_active {
            span {
                text-decoration: underline;
            }
        }
    }
}

.sm-title {
    background: #f9f9f9;
    position: relative;
    margin: 0 -16px;
    padding: 0 32px;
    display: flex;
    height: auto;
    justify-content: center;
    text-align: left;
    min-height: 36px;
    .return-btn {
        position: absolute;
        left: 16px;
        cursor: pointer;
        svg {
            display: block;
        }
    }
}

.p0 {
    padding: 0 !important;
}

.no_border {
    border-bottom: none !important;
}

.help-sm {
    flex-grow: 1;
    // margin-top: -36px;
    padding-bottom: 32px;
    .sidebar-sm {
        background: #fff;
        padding: 32px 16px;
        height: 100%;
        display: flex;
        flex-direction: column;
        min-height: 520px;
        &__tabs {
            font-style: normal;
            font-weight: normal;
            font-size: 11px;
            line-height: 140%;
            letter-spacing: 0.16em;
            .tab {
                cursor: pointer;
                padding: 12px 0px;
                border-bottom: 1px solid @border2;
                &__title {
                    &.is_open {
                        margin-bottom: 20px;
                    }
                }
            }
        }
        &__footer {
            color: #000;
            margin-top: auto;
            &--title {
                color: #a6a6a6;
                margin-bottom: 24px;
            }
            &--info {
                display: flex;
                margin-bottom: 8px;
                a {
                    display: flex;
                    align-items: center;
                    margin-right: 8px;
                    svg {
                        margin-right: 8px;
                    }
                }
                div {
                    color: #a6a6a6;
                }
            }
            &--mail {
                display: block;
                margin-bottom: 26px;
            }
            .button {
                margin-top: 17px;
                display: flex;
                max-width: 162px;
                font-style: normal;
                font-weight: normal;
                font-size: 13px;
                line-height: 100%;
            }
        }
    }
    .modal-sm {
        margin-top: -37px;
        background: #f9f9f9;
        &__title {
            position: relative;
        }
        &__content {
            padding: 16px;
            height: calc(100% - 36px);
            overflow-y: auto;
        }
    }
}
.return-btn {
    position: absolute;
    left: 21px;
    cursor: pointer;
}
</style>
